import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[ostsoActionTemplate]',
    standalone: true,
})
export class TableActionDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
